import { useEffect } from 'react'

const ErrorTest = () => {
    useEffect(() => {
        throw new Error('This is test error')
    }, [])

    return <div>This is test error page</div>
}

export default ErrorTest
